export const createAccount = `
    mutation CreateAccount($input: CreateAccountInput!) {
        createAccount(input: $input) {
            id
            sub
            username
            email
            accountType
            accountStatus
            customerId
            created
            updated
        }
    }
`;

export const updateAccount = `
    mutation UpdateAccount($input: UpdateAccountInput!) {
        updateAccount(input: $input) {
            id
            sub
            username
            email
            accountType
            accountStatus
            customerId
            created
            updated
        }
    }
`;

// FNP-955: deleteAccount returns Account, not ID. The checked-in schema copy
// still showed the pre-FNP-285 `: ID` signature, so this mutation shipped with
// no sub-selection and every call failed validation at the API with
// "SubSelectionRequired". The selection set mirrors restoreAccount below —
// both return the mutated Account so the UI can reflect the new
// accountStatus + retention fields without a refetch.
export const deleteAccount = `
    mutation DeleteAccount($input: DeleteAccountInput!) {
        deleteAccount(input: $input) {
            id
            sub
            username
            email
            accountType
            accountStatus
            customerId
            deletionRequestedAt
            deletionRequestedBy
            scheduledHardDeleteAt
            created
            updated
        }
    }
`;

// FNP-383: restoreAccount flips a PENDING_DELETION account back to ACTIVE
// within the 30-day retention window. Admin-only on the backend (FNP-382
// directive). The mutation returns the restored Account so the UI can
// reflect the new accountStatus + cleared retention fields immediately.
export const restoreAccount = `
    mutation RestoreAccount($input: RestoreAccountInput!) {
        restoreAccount(input: $input) {
            id
            sub
            username
            email
            accountType
            accountStatus
            customerId
            created
            updated
        }
    }
`;
